// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { Monitor, Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const THEMES = [
  { value: "light", icon: Sun },
  { value: "dark", icon: Moon },
  { value: "system", icon: Monitor },
] as const;

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const { t } = useTranslation("back-office");

  const Icon = theme === "dark" ? Moon : theme === "system" ? Monitor : Sun;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="h-8 w-8">
          <Icon className="h-4 w-4" />
          <span className="sr-only">{t("commandPalette.theme.title")}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" sideOffset={-32} className="dropdown-overlap">
        {THEMES.map((th) => (
          <DropdownMenuItem
            key={th.value}
            onSelect={() => setTheme(th.value)}
            className={
              theme === th.value
                ? "bg-sidebar-accent-hover text-sidebar-accent-foreground focus:bg-sidebar-accent focus:text-sidebar-accent-foreground dark:bg-sidebar-accent dark:focus:bg-sidebar-accent-hover"
                : ""
            }
          >
            <th.icon className="h-4 w-4" />
            {t(`commandPalette.theme.${th.value}`, th.value)}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
